export default __webpack_public_path__ + "static/media/MuangThai.93249e57.png";